import React, { useState } from "react";
import { useParams, Redirect } from "react-router-dom";
import { notification } from "antd";
import axios from "axios";

import { sair } from "../../../../assets/menu";

import styles from "./BarraAreaAluno.module.scss";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
        iconLoading: false
    });
};

export default function BarraAreaAluno(props) {
    const [redirect, setRedirect] = useState(false);

    const { entidade } = useParams();

    const logOut = () => {
        axios({
            method: "post",
            url: "/api/autenticacao/logout"
        })
            .then(() => {
                localStorage.removeItem("accessToken");
                delete axios.defaults.headers.common.Authorization;
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro ao sair.");
            })
            .finally(() => {
                setRedirect(true);
            });
    };

    if (redirect) return <Redirect to={`/${entidade}?area-aluno=aberto`} />;

    return (
        <div className={styles.barra}>
            <div className={styles.nome}>
                <span> {props.nome} </span>
            </div>
            <div>
                <button
                    className={`nav-link botao-principal botao-sair ${styles.botaoSair}`}
                    onClick={logOut}
                >
                    <span>
                        <img src={sair} alt="sair" />
                    </span>
                    <span className={styles.textoSair}>Sair</span>
                </button>
            </div>
        </div>
    );
}
